import React from "react"

import {ProviderList} from "components/backoffice/Storage/Provider/List/ProviderList"

export const ProviderListRoute = (props: any) => {

  return <div>
    <ProviderList />
  </div>
}